<template>
  <div class="teacher" v-if="enabled">
    <router-view></router-view>
    <div class="joinTip" ref="joinTip">
      <div class="tipPanel">
        <div class="tipTitle">
          <span style="">学生加入方式</span>
          <span class="el-icon-close" @click="closeTip"></span>
        </div>
        <div class="tipBody">
          <div class="join1">
            <span class="joinWay">方式一：登录<a>https://program-live.gaoxiaobang.com</a>输入教室ID</span>
            <div class="roomId">
              <span class="id">{{roomId}}</span>
              <span>教室ID</span>
            </div>
          </div>
          <div class="join2">
            <span class="joinWay">方式二：通过链接直接加入</span>
            <div class="roomUrl">
              <span class="url" ref="url">{{studentUrl}}</span>
              <span class="copyBtn" @click="copyUrl">点击复制</span>
            </div>
            <transition name="fade" v-on:after-enter="afterEnter">
              <span v-if="copy" class="copytip">已复制</span>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <router-link :to="{name: 'Prepare', params:{roomId: roomId, languageId: languageId}}" target="_blank">
      <div class="codeLibrary">
        <a>代码库</a>
      </div>
    </router-link>

    <!--随堂问卷（新）-->

    <div class="ex-dialog ex-tips-dialog" v-show="showQuestionnaireTips">
      <div class="ex-main">
        <div class="ex-header">
          <div class="ex-title">提示</div>
          <i class="ex-close" @click="showQuestionnaireTips=false"></i>
        </div>
        <div class="ex-body">
          <div class="tips-text">如有需要，可在发布问卷之前选中代码片段，帮助描述问题</div>
          <div class="ex-btn-box">
            <div class="disable-tips" @click="disableQuestionnaireTips=!disableQuestionnaireTips"><i class="ex-checkbox" :class="{ active: disableQuestionnaireTips }"></i>不再提醒</div>
            <div class="ex-flex">
              <div class="ex-btn ex-active-btn" @click="showQuestionnaireTips=false">去选中</div>
              <div class="ex-link" @click="showQuestionnaireTips=false;showQuestionnaire=true">跳过</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ex-dialog ex-qn-dialog" v-if="initedQuestionnaire" v-show="showQuestionnaire">
      <div class="ex-main">
        <div class="ex-header">
          <div class="ex-title">随堂问卷</div>
          <i class="ex-close" @click="showQuestionnaire=false;showQuestionnaireSuccess=false"></i>
        </div>
        <div class="ex-body" v-show="showQuestionnaireSuccess">
          <i class="ex-success-icon"></i>
          <div class="ex-success-tips">发布成功！学生正在回答中…</div>
        </div>
        <div class="ex-body" v-show="!showQuestionnaireSuccess">
          <div class="ex-label">输入问题</div>
          <input type="text" class="ex-title-input" v-model="questionnaireTitle" placeholder="请输入对学生提出的问题（必填）" />
          <div class="ex-code-input-wrap">
            <!--<div class="ex-parse-btn">粘贴代码</div>-->
            <code-panel ref="codepanel"></code-panel>
          </div>
          <div class="ex-btn-box">
            <div class="ex-link ex-history-link" @click="showQuestionnaire=false;showQuestionnaireHistory=true">历史问卷反馈</div>
            <div class="ex-btn ex-submit-btn" :class="{ disabled: !questionnaireTitle }" @click="questionnaireTitle&&submitQuestionnaire()">提交</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ex-dialog ex-qn-history-dialog" v-show="showQuestionnaireHistory">
      <div class="ex-main">
        <div class="ex-header">
          <div class="ex-title">历史问卷反馈</div>
          <i class="ex-close" @click="showQuestionnaireHistory=false"></i>
        </div>
        <div class="ex-body">
          <div class="ex-empty-tips" v-if="questionData.length === 0">暂无数据</div>
          <ul class="ex-list" v-else>
            <li class="ex-item" v-for="(q, index) in questionData" :key="'question-'+index">
              <div class="ex-item-title">
                <span class="ex-item-title-text">{{q.question}}</span>
                <i class="icon iconfont icon-wenben" v-tooltip="{content: q.code.replace(/\n/g, '<br/>').replace(/ /g, '&nbsp;'), classes: 'code-tooltip', boundariesElement: 'viewport', placement: 'right' }"></i>
              </div>
              <div class="ex-info-box">
                <span class="ex-agree-count"><i class="icon iconfont icon-haoping"></i>{{q.yes}}人</span>
                <span class="ex-disagree-count"><i class="icon iconfont icon-chaping"></i>{{q.no}}人</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  // import kHeader from '@/components/Header'
  import Iterm from '@/components/Iterm'
  import kFooter from '@/components/Footer'
  import CodePanel from '@/components/CodePanel'
  import {
    ajaxAPI
  } from '@/utils/ajaxUtil'
  import {
    HYBIRD_URL,
    url
  } from '@/config/url_config'
  import {
    exportFile
  } from '@/utils/utils'
  import IO from 'socket.io-client'
  import EventBus from '@/views/eventBus'
  import {
    getUrlParam,
    generateUUID
  } from '@/common/js/utils'
  export default {
    components: {
      // kHeader,
      Iterm,
      kFooter,
      CodePanel
    },
    data() {
      return {
        enabled: true,
        headerData: {
          role: '教师端',
          roomId: this.$route.params.roomId,
          number: '0'
        },
        chat: '',
        roomId: this.$route.params.roomId,
        studentUrl: '',
        languageId: this.$route.params.languageId,
        copy: '',
        isLive: 0,
        questionData: [],
        isActiveTip: false,
        teachIsLive: false,

        showQuestionnaireTips: false,
        disableQuestionnaireTips: false,

        showQuestionnaire: false,
        initedQuestionnaire: false,
        questionnaireTitle: '',
        showQuestionnaireSuccess: false,
        showQuestionnaireHistory: false
      }
    },
    computed: {
      codepanel() {
        return this.$refs.codepanel.editor
      }
    },
    created() {},
    watch: {
      showQuestionnaire() {
        this.initedQuestionnaire = true
      }
    },
    mounted() {

      if (this.languageId === '35') {
        this.studentUrl = `${window.location.host}/#/room/${this.roomId}/web`
      } else {
        this.studentUrl = `${window.location.host}/#/room/${this.roomId}/language/${this.languageId}`
      }

      this.eventBusFun()
      this.initSocket()
      window.onbeforeunload = function (e) {
        return '确认退出？ 将不保存你的代码'
      }
    },
    methods: {
      eventBusFun() {
        let _this = this
        EventBus.$on('showQuestionPanel', function () {
          if (_this.disableQuestionnaireTips) {
            _this.showQuestionnaire = true
          }
          else {
            _this.showQuestionnaireTips = true
          }
        })
      },
      initSocket() {
        let _this = this;
        let userInfo = {
          uuid: generateUUID(),
          roomId: this.$route.params.roomId,
          role: 'teacher',
          token: getUrlParam('token') || window.localStorage.getItem('accessToken'),
          source: getUrlParam('source') || window.localStorage.getItem('source')
        }

        this.socket.on('connect', function () {
          console.log('已连接')
        })

        this.socket.emit('join.room', userInfo)

        this.socket.on('teacher.init', function(roomData) {
          this.questionData = roomData.questionData
        })

        this.socket.on('error', function (err) {
          if (!err.uuid || err.uuid == userInfo.uuid) {
            if (err.code == 'token_error') {
              if (userInfo.source) {
                location.href = decodeURIComponent(userInfo.source);
              } else {
                _this.$router.push('Home');
              }
            } else {
              _this.enabled = false;
              _this.$error(err.msg);
            }
          }
        })

        this.socket.on('class.questionnaire.data', (data) => {
          this.questionData = data
        })
      },
      closeTip() {
        this.$refs.joinTip.style.display = 'none'
      },
      copyUrl() {
        /* 创建range对象   */
        const range = document.createRange()
        range.selectNode(this.$refs.url) //  设置range要包含的节点对象
        /* 窗口的selection对象，表示用户选择的文本 */
        const selection = window.getSelection()
        if (selection.rangeCount > 0) selection.removeAllRanges() // 将已经包含的已选择的对象清除掉
        selection.addRange(range) // 将要复制的区域的range对象添加到selection对象中
        document.execCommand('copy') // 执行copy命令，copy用户选择的文本

        this.copy = true
      },
      prepareLession() {
        let roomId = this.roomId
        this.$router.push({
          name: 'Prepare',
          params: {
            roomId: roomId
          }
        })
      },
      afterEnter() {
        let _this = this
        setTimeout(function () {
          _this.copy = ''
        }, 2000)
      },

      submitQuestionnaire() {
        window.codePa = this.codepanel;

        let data = {
          roomId: this.roomId,
          question: this.questionnaireTitle,
          code: this.codepanel.getValue(),
          yes: 0,
          no: 0,
          total: 0
        }
        this.socket.emit('class.questionnaire', data)


        this.questionnaireTitle = ''
        this.codepanel.setValue('')
        this.showQuestionnaireSuccess = true
        setTimeout(()=>{
          this.showQuestionnaire = false
          this.showQuestionnaireSuccess = false
          this.showQuestionnaireHistory = true
        }, 3000)
      }
    }
  }

</script>

<style lang="scss">
  @import url('../../style/main.scss');
  .teacher {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #eee;
    overflow: hidden;

    .el-tabs__header {
      background-color: #F4F6F9;
    }
    .iterm-wrap {
      height: 260px;
    }
    .joinTip {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 99999;

      .tipPanel {
        width: 80%;
        max-width: 680px;
        height: 440px;
        position: absolute;
        background-color: #FFF;
        top: 15%;
        left: 50%;
        transform: translate(-50%);
        font-weight: normal;

        .tipTitle {
          height: 39px;
          padding: 10px 30px;
          border-bottom: 1px solid rgba(209, 211, 212, .4);
          line-height: 39px;
          text-align: left;
          color: #D1D3D4;
          display: flex;
          justify-content: space-between;
          font-size: 16px;

          span:first-child {
            color: #22B8FF;
            letter-spacing: 10px;
            font-size: 20px
          }

          .el-icon-close {
            position: relative;
          }
          .el-icon-close:before {
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .tipBody {

          margin: 60px auto;
          color: #8B9194;

          .joinWay {
            margin-left: 60px;
          }
          .join1 {
            .joinWay {
              a {
                color: #22B8FF
              }
            }

            .roomId {
              text-align: center;
              margin: 30px auto 40px auto;
              width: 220px;
              height: 80px;
              background: rgba(34, 184, 255, .1);
              padding: 15px 31px;

              span {
                display: block;
              }
              span:last-child {
                line-height: 35px;
              }
              .id {
                font-size: 32px;
                letter-spacing: 10px;
                color: #22B8FF;
              }
            }
          }
          .join2 {
            .roomUrl {
              margin: 20px auto 40px auto;
              height: 26px;
              padding-left: 114px;

              .url {
                display: inline-block;
                font-size: 12px;
                background: rgba(34, 184, 255, .1);
                padding: 7px 20px;
                margin-right: 20px;
                color: #22B8FF;
              }
            }
          }
          .copytip {
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .codeLibrary {
      position: absolute;
      z-index: 999;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      box-shadow: 0 0 4px 0 rgba(179, 229, 255, 1);
      width: 60px;
      height: 30px;
      text-align: center;
      background-image: -webkit-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
      background-image: -o-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
      background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
      color: #fff;
      cursor: pointer;

      a {
        line-height: 30px;
        color: #fff;
      }
    }
    .question {
      position: absolute;
      width: 540px;
      min-height: 300px;
      padding: 14px;
      z-index: 999;
      top: 54px;
      left: 50%;
      transform: translate(-50%, 0);
      background: #fff;
      text-align: center;
      border-radius: 4px;
      .close {
        position: absolute;
        top: 4px;
        right: 8px;
        cursor: pointer;
      }
      .q-input {
        width: 80%;
        margin: 0 auto;
        input {
          width: 100%;
          height: 32px;
          margin-bottom: 12px;
        }
      }
      .code-wrap {
        width: 80%;
        height: 100px;
        margin: 16px auto;
        text-align: left;
        border: 1px solid #dfdede;
      }
      .result-wrap {
        width: 80%;
        overflow: auto;
        padding: 12px;
        border-top: 1px solid #e7e7e7;
        margin: 8px auto 0px;
      }
      .nulldata {
        color: #bbbcbc;
      }
      .q-result {
        max-height: 250px;
      }
      .tb-wrap {
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        button {
          letter-spacing: 4px;
          font-weight: 300;
          border: 0;
          cursor: pointer;
          font-size: 14px;
        }
        .check {
          color: #1FB6FF;
        }
        .refer {
          background: #1FB6FF;
          border-radius: 20px;
          padding: 4px 8px;
          color: #fff;
        }
      }
      .icon-wenben {
        color: #1FB6FF;
      }
      .icon-haoping {
        color: #1FB6FF;
      }
      .qr-iterm {
        text-align: left;
        position: relative;
        background: #F0F3F5;
        margin-bottom: 8px;
        padding: 4px 8px;
        color: #3D474D;
        h2 {}
        .qcode-panel {
          font-weight: 100;
          font-size: 14px;
          position: absolute;
          top: 28px;
          width: 100%;
          min-height: 100px;
          background: #fff;
          z-index: 999;
          padding: 6px 10px;
        }
        p {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
    .ex-left {
      float: left;
    }
    .ex-right {
      float: right;
    }
    .ex-flex {
      display: flex;
      align-items: center;
    }
    .ex-link {
      color: #1FB6FF;
      cursor: pointer;
    }
    .ex-btn {
      background: linear-gradient(to left, #1FB6FF, #66CCFF);
      color: #fff;
      cursor: pointer;
      text-align: center;

      &.disabled {
        background: #999;
        cursor: not-allowed;
      }
    }
    .ex-dialog {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.6);
      z-index: 10000;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 1;
      .ex-main {
        background: #fff;
        border-radius: 4px;

        .ex-header {
          height: 60px;
          line-height: 60px;
          border-bottom: 1px solid #D1D3D4;
          padding: 0 30px;
          display: flex;
          align-items: center;
          .ex-title {
            flex: 1;
            font-size: 16px;
            letter-spacing: 0.5em;
            color: #22B8FF;
          }
          .ex-close {
            flex: 0 0 auto;
            margin-right: -5px;
            width: 30px;
            height: 30px;
            background: url(../../assets/icon-close.png) center no-repeat;
            cursor: pointer;
          }
        }
        .ex-body {
          padding: 0 40px;
        }
      }

      &.ex-tips-dialog {
        .ex-main {
          width: 460px;
          height: 240px;
          .tips-text {
            padding: 40px 0;
            text-align: center;
            font-size: 14px;
            color: #8B9194;
            line-height: 1;
          }
          .ex-btn-box {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .disable-tips {
              color: #8B9194;
              font-size: 14px;
              display: flex;
              align-items: center;
              cursor: pointer;
              .ex-checkbox {
                margin-right: 10px;
                width: 16px;
                height: 16px;
                border-radius: 4px;
                border: 1px solid rgba(36,170,255,.58);

                &.active {
                  background: url(../../assets/icon-right.png) center no-repeat;
                }
              }
            }
            .ex-active-btn {
              margin-right: 20px;
              width: 90px;
              height: 34px;
              line-height: 34px;
              border-radius: 17px;
            }
          }
          
        }
      }

      &.ex-qn-dialog {
        .ex-main {
          width: 560px;
          min-height: 420px;
          .ex-body {
            .ex-label {
              margin-top: 30px;
              color: #666;
            }
            .ex-title-input {
              box-sizing: border-box;
              margin-top: 5px;
              display: block;
              width: 100%;
              height: 45px;
              border: none;
              background: rgba(34, 184, 255, 0.1);
              font-size: 18px;
              padding: 0 10px;
              &:focus {
                outline: none;
                
              }
            }
            .ex-code-input-wrap {
              margin-top: 20px;
              height: 120px;
              border: 1px dashed #1FB6FF;
              border-radius: 6px;
            }
            .ex-btn-box {
              margin-top: 50px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .ex-history-link {
                background: url(../../assets/icon-clock.png) left center no-repeat;
                padding-left: 20px;
                line-height: 20px;
              }
              .ex-submit-btn {
                width: 80px;
                height: 28px;
                line-height: 28px;
                border-radius: 14px;
              }
            }

            .ex-success-icon {
              margin-top: 40px;
              display: block;
              width: 100%;
              height: 175px;
              background: url(../../assets/img-success.png) center no-repeat;
            }
            .ex-success-tips {
              margin-top: 25px;
              text-align: center;
              color: #8B9194;
            }
          }
        }
      }
      &.ex-qn-history-dialog {
        .ex-main {
          width: 560px;
          .ex-body {
            padding: 30px 40px;
            .ex-list {
              height: 320px;
              overflow: auto;
              .ex-item {
                box-sizing: border-box;
                height: 80px;
                padding: 20px;
                background: #F0F3F5;
                color: #3D474D;
                &:nth-child(n+2) {
                  margin-top: 10px;
                }

                .ex-item-title {
                  display: flex;
                  align-items: center;

                  .ex-item-title-text {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  .icon-wenben {
                    flex: 0 0 auto;
                    margin-left: 5px;
                    font-size: 12px;
                    cursor: pointer;
                    &:hover {
                      color: #1FB6FF;
                    }
                  }
                }
                .ex-info-box {
                  margin-top: 10px;
                  display: flex;
                  align-items: center;
                  .ex-agree-count, .ex-disagree-count {
                    width: 140px;
                    font-size: 12px;
                    .iconfont {
                      margin-right: 6px;
                      cursor: auto;
                    }
                    .icon-haoping {
                      color: #1FB6FF;
                    }
                  }
                }
              }
            }
          }
          
        }
      }
    }
    .t-header {
      display: flex;
      border-bottom: 1px solid #D1D3D4;
      justify-content: space-between;
      padding: 0 4px 8px;
      margin-bottom: 18px;
    }
    .t-info {
      padding: 0 12px;
      color: #8B9194;
    }
    .t-btn {
      display: flex;
      justify-content: space-between;
      margin: 44px 12px 12px;
      span {
        padding: 2px 8px;
        cursor: pointer;
        color: #1FB6FF;
      }
      .t-select {
        background-image: -webkit-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
        background-image: -o-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
        background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
        color: #fff;
        border-radius: 14px;
      }
    }
  }

  .copyBtn {
    display: inline-block;
    line-height: 26px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 20px;
    background: #1FB6FF;
    color: #fff;
    border: 0;
    cursor: pointer;
  }

  .v-line {
    width: 0
  }

</style>



// WEBPACK FOOTER //
// teacher.vue?d0f14a7a